"use strict";

var _slicedToArray = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Modal = void 0;

var tslib_1 = require("tslib");
/* eslint-disable no-console */
// @ts-nocheck


var react_1 = tslib_1.__importStar(require("react"));

var Modal_style_1 = require("./Modal.style");

var CONTAINER_ID = 'root';
var ESCAPE_KEY = 'Escape'; // @ts-ignore

var Modal = function Modal(_ref) {
  var isOpen = _ref.isOpen,
      onClose = _ref.onClose,
      children = _ref.children;

  var _ref2 = (0, react_1.useState)(null),
      _ref3 = _slicedToArray(_ref2, 2),
      container = _ref3[0],
      setContainer = _ref3[1];

  (0, react_1.useLayoutEffect)(function () {
    var modalRoot = document.getElementById(CONTAINER_ID);

    if (!modalRoot) {
      console.warn("@8base-react/file-input: container with ".concat(CONTAINER_ID, " id does not exist"));
      return;
    }

    setContainer(modalRoot);
  }, []);
  var onDocumentKeyPress = (0, react_1.useCallback)(function (event) {
    if (event.key === ESCAPE_KEY) {
      onClose();
    }
  }, [onClose]);
  (0, react_1.useLayoutEffect)(function () {
    document.addEventListener('keydown', onDocumentKeyPress);
    return function () {
      document.removeEventListener('keydown', onDocumentKeyPress);
    };
  }, [onDocumentKeyPress]);

  if (!isOpen) {
    return null;
  }

  if (!container) {
    return null;
  }

  return (// eslint-disable-next-line jsx-control-statements/jsx-use-if-tag
    isOpen ? // If isOpen is true, render the following JSX
    react_1.default.createElement("div", {
      className: Modal_style_1.MODAL_STYLE.overlay
    }, react_1.default.createElement("div", {
      className: Modal_style_1.MODAL_STYLE.content
    }, children)) : undefined // If isOpen is false, render nothing (undefined)

  );
};

exports.Modal = Modal;